// Consultation/clientRequest.ts
import {Message} from 'Core/components/Message';
import moment from 'moment';
import {ClientRequest} from '../ConsultationPackage/PackageOrder';

import {Location, NavigateFunction} from 'react-router-dom';
import {redirectWithNextBack} from "../../Utils/redirectNext";
import pprint from "../../Utils/pprint";

export function checkClientRequest(slotRequired: boolean, navigate: NavigateFunction, location: Location): ClientRequest | null {
    const storedClientRequest = localStorage.getItem('clientRequest');
    if (!storedClientRequest) {
        Message.error('Необходимо заполнить данные перед оформлением заказа.');
        redirectWithNextBack(navigate, location, '/questionnaire/general');
        return null;
    }

    const clientRequest: ClientRequest = JSON.parse(storedClientRequest);
    // Проверка на наличие reservation_paid в URL
    const urlParams = new URLSearchParams(location.search);
    const reservationPaidInURL = urlParams.has('reservation_paid');
    if (!reservationPaidInURL && 'reservation_paid' in clientRequest) {
        pprint('Убираем reservation_paid из clientRequest, так как его нет в URL');
        delete (clientRequest as any).reservation_paid;
        localStorage.setItem('clientRequest', JSON.stringify(clientRequest));
    }
    if (slotRequired) {
        if (!clientRequest.selected_slot) {
            Message.error('Необходимо выбрать время консультации.');
            redirectWithNextBack(navigate, location, `/psychologists/${clientRequest.psychologist.id}?config=${clientRequest.consultation_config.id}`);
            return null;
        }

        clientRequest.selected_slot = moment(clientRequest.selected_slot);

        if (!clientRequest.selected_slot.isValid()) {
            Message.error('Некорректное время консультации. Пожалуйста, выберите другое.');
            redirectWithNextBack(navigate, location, `/psychologists/${clientRequest.psychologist.id}?config=${clientRequest.consultation_config.id}`);
            return null;
        }

        const currentMoment = moment();
        if (clientRequest.selected_slot.isBefore(currentMoment)) {
            Message.error('Выбранное время консультации уже прошло, выберите время снова.');
            redirectWithNextBack(navigate, location, `/psychologists/${clientRequest.psychologist.id}?config=${clientRequest.consultation_config.id}`);
            return null;
        }
    }

    if (!clientRequest.psychologist) {
        Message.error('Необходимо выбрать психолога перед заказом.');
        redirectWithNextBack(navigate, location, '/psychologists');
        return null;
    }

    pprint('Picked data loaded:', clientRequest);

    return clientRequest;
}
